<template>
  <div>
    <scope-list></scope-list>
  </div>
</template>

<script>
import ScopeList from './ScopeList.vue';

export default {
  components: {
    ScopeList,
  },

  data() {
    return {};
  },
};
</script>
